<div id="app">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
